export default [
  {
    text: 'Name',
    value: 'name',
  },
  {
    text: 'Country',
    value: 'countries',
    apiSort: 'country',
  },
  {
    text: 'Status',
    value: 'status.name',
    apiSort: 'status',
    width: '180px',
  },
];
